import { withProjectCardStyle } from 'root/src/client/web/list/listItemComponents/style'
import { useDareCard } from 'root/src/client/web/list/listItemComponents/dare/hooks/useDareCard'
import classNames from 'classnames'
import { DareCardTypeIcon } from 'root/src/client/web/list/listItemComponents/project/ProjectCardCircleImage'
import {
	categoriesMap,
	colorsNew,
} from 'root/src/client/web/commonStyles'
import { readableDropDareTypes } from 'root/src/shared/constants/dropEvent'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'

export const DareCardSeparator = withProjectCardStyle(({ classes }) => {
	const {
		dare: { level, type, battlePass },
		extraData: {
			brand,
		},
	} = useDareCard()

	if (battlePass) {
		return (
			<div className={classNames(
				'layout-row layout-align-center',
				classes.projectAssigne,
				classes.overlay,
			)}
			>
				<BattlePassTierBadge tier={battlePass.tier} />
				<div className={classes.namesContainer}>
					<BattlePass battlePass={battlePass} />
					<Difficulty level={level} />
				</div>
			</div>
		)
	}

	return (
		<div className={classNames(
			'layout-row layout-align-center',
			classes.projectAssigne,
			classes.overlay,
		)}
		>
			<DareCardTypeIcon
				icon={categoriesMap[type].icon}
				alt={brand.brandName}
			/>
			<div className={classes.namesContainer}>
				<Type type={type} />
				<Difficulty level={level} />
			</div>
		</div>
	)
})

const Difficulty = withProjectCardStyle(({ classes, level }) => (
	<div style={{
		display: 'flex',
		flexDirection: 'column',
		fontSize: 12,
		alignItems: 'center',
		justifyContent: 'center',
	}}
	>
		<Typography
			color={colorsNew.light4}
			variant={typographyVariants.microBold}
		>
			DIFFICULTY
		</Typography>
		<Typography className={classes.uppercase} variant={typographyVariants.mini}>
			{level}
		</Typography>
	</div>
))

const BattlePass = ({ battlePass }) => (
	<div className="ml-4 flex flex-initial flex-col gap-0.5 justify-center">
		<span className="uppercase text-left text-2xs text-light-4">Battle pass</span>
		<span
			title={battlePass.name}
			className="uppercase text-left text-xs truncate max-w-40"
		>
			{battlePass.name}
		</span>
	</div>
)

const BattlePassTierBadge = ({ tier }) => (
	<div className="flex flex-initial flex-col justify-center items-center tracking-wide h-[50px] w-[50px] rounded-full drop-shadow-teal-glow bg-black border-2 border-white">
		<span className="text-2xs text-teal text-center">Tier</span>
		<span className="text-center font-bold">{tier}</span>
	</div>
)

const Type = withProjectCardStyle(({ classes, type }) => (
	<p className={classes.assigneesNames}>
		{readableDropDareTypes[type]}
	</p>
))
